/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { Grid, Typography } from '@mui/material'
import { ReduxStateDashboard } from '@reducers/dashboardNext/toolkit'
import moment from 'moment'
import React, { useMemo } from 'react'
import distanceIcon from '../assets/distance.png'
import membersIcon from '../assets/members.png'
import stepsIcon from '../assets/steps.png'
import useFormattedNumber from '../../hooks/useFormattedNumber'

const cssIcon = css`
  width: 20px;
  height: 20px;
  object-fit: contain;
`

const cssMetricItem = css`
  margin-bottom: 7px;
`
const cssMetricTitle = css`
  font-weight: bold;
  margin-left: 10px;
  margin-right: 7px;
  font-size: 14px;
`

const cssMetricValue = css`
  font-size: 14px;
`

interface Props {
  info: any
}
function StepsPathMetrics(props: Props) {
  const { info } = props
  const { valueTotal: steps = 0, challenge_item_start_at: start_at } = info || {}

  const startFormatted = useMemo(() => {
    if (!start_at) return null
    return moment(start_at, 'YYYY-MM-DD').format('LL')
  }, [start_at])

  const stepsFormatted = useFormattedNumber(steps)

  return (
    <div>
      <Grid container css={cssMetricItem}>
        <img css={cssIcon} src={stepsIcon} alt={'steps'} />
        <Typography css={cssMetricTitle}>Total Steps</Typography>
        <Typography css={cssMetricValue}>{stepsFormatted}</Typography>
      </Grid>

      <Grid container css={cssMetricItem}>
        {/*<img css={cssIcon} src={distanceIcon} alt={''} />*/}
        <Typography css={cssMetricTitle}>Start Date</Typography>
        <Typography css={cssMetricValue}>{startFormatted}</Typography>
      </Grid>
    </div>
  )
}

export default StepsPathMetrics
